import React from 'react';
import { ButtonV2 } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { useMobileView } from '../../useMobileView';
import { ChevronRightSquare } from '@withjoy/joykit/icons';
import { useMobileViewContext } from '../../MobileView.provider';
import { Wrapper, Container, styles } from './MobileLoggedInMenu.styles';

export const MobileLoggedInMenu: React.FC = () => {
  const { resourceRedirectLinks } = useMobileView();
  const { onClickMainMenu } = useMobileViewContext();
  return (
    <Wrapper __css={styles.wrapper}>
      <Container __css={styles.container}>
        {resourceRedirectLinks.map(({ type, heading }) => (
          <ButtonV2
            key={type}
            typographyVariant="FeatureHead17"
            fontWeight={700}
            height={pxToRem(26)}
            padding={0}
            intent="neutral"
            variant="ghost"
            justifyContent="space-between"
            endIcon={<ChevronRightSquare marginTop={2} />}
            onClick={() => onClickMainMenu(type)}
          >
            {heading}
          </ButtonV2>
        ))}
      </Container>
    </Wrapper>
  );
};
